export default __webpack_public_path__ + "static/media/virtual_group_bg.1cd26378.jpg";